import React , { useEffect , useState } from 'react'

import { Row , Col, Container } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {   faRightLong , faLeftLong , faXmarkCircle , faFileInvoice , faTrash , faDownload } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'


import { ApiCallPost } from '../ApiCall/ApiCall'
import AlertPrecaucion from './Alerts/AlertPrecaucion'
import AlertSinDatos from './Alerts/AlertSinDatos'
import AlertBorradoExit from './Alerts/AlertBorradoExit'

import Select from 'react-select';


function FormCatConfig( {close}) {

    const [precaucion,setPrecaucion] = useState( false ) ;
    const [sinDatos,setSinDatos] = useState( false )
    const [borradoExit,setBorradoExit] = useState( false ) ;

function cerrarBorrado()
{
    setBorradoExit( false )
}

function cerrarSinDatos()
{
    setSinDatos( false ) ;
}


function onSaveAll()
{
    var selObj = document.getElementById( "codlocal") ;


    if ( selObj.options.length === 0 )
    {
        return ;
    }

    var arr = [] ;

    //selectedText.push( selObj.options[i].text )
    //selectedValue.push( selObj.options[i].value )
 
    for( var i = 0 ; i < selObj.options.length ; i++ )
    {
        console.log( "text = " + selObj.options[i].text )
        console.log( "text = " + selObj.options[i].value  )
        var obj = {
            text : selObj.options[i].text ,
            value : selObj.options[i].value
        }

        arr.push( obj )

    }

    var data = {
        arr : arr ,
    }

    console.log( "Antes de llamar " , data )

    //return ;

    ApiCallPost( "savecodigoagrupador" , data )
    .then((response) => {

        console.log( "Llego respuesta " , response ) ;

    })
    .catch((err) => {
        console.log( err)
    })



    

}

function aceptarPrecaucion()
{
    console.log( "Nos llega aceptar precaucion")
    setPrecaucion( false )


    var selObj = document.getElementById( "codlocal") ;


    //var selectedIndex = []
    var selectedValue = []



    for (var i=0; i<selObj.options.length; i++) { 
        if (  true /*selObj.options[i].selected*/) {

            //selectedIndex.push( i ) ;
            selectedValue.push( selObj.options[i].value )
        
        } 

    } // Ya tenemos la lista que mandamos borrar


    removeData( selectedValue , true ) ; // Si requiero que vuelvan a borrar


    //onEraseAll2() 
    
}

function cerrarPrecaucion()
{
    console.log( "cerrar precaucion")
    setPrecaucion( false ) ;
}


function onEraseAll()
{

    var select = document.getElementById('codlocal') ;

    if( select.length === 0 )
    {
        setSinDatos( true ) ;
        return ;
    }

    setPrecaucion( true ) ;



}

function onEraseAll2()
{
    var select = document.getElementById('codlocal') ;


    if ( select === null || select === undefined)
    {
        console.log( "no encontre el codigo") ;
        return ;
    }


    while( select.length > 0 )
    {
        select.remove( select.length -1 ) ;
    }

}


function onLeft()
{
    console.log( "onLeft")

    var selObj = document.getElementById( "codlocal") ;


    var selectedIndex = []
    var selectedValue = []





    for (var i=0; i<selObj.options.length; i++) { 
        if (selObj.options[i].selected) {

            selectedIndex.push( i ) ;
            selectedValue.push( selObj.options[i].value )
        
        } 

    }


    console.log( "selectedIndex = " + selectedIndex.length ) ;


    if ( selectedIndex.length === 0 )
    {


        setSinDatos( true ) ; 
        return ;
    }



    for( i = selectedIndex.length -1 ; i >=0  ; i--)
    {
        console.log( "Borrando " + i )
        selObj.remove( selectedIndex[i] ) ;

    }


    removeData( selectedValue  , false ) // No requiero que vuelvan a borrar


}

function removeData( arr , isRemove )
{
    var obj = {
        arr : arr 
    }

    ApiCallPost( "removecodigoagrupador" , obj )
    .then((response) => {

        console.log( "Llego respuesta " , response ) ;

        if ( true /* isRemove */)
        {
            cleanResponse( response.arr ) ; 
        }

    })
    .catch((err) => {
        console.log( err)
    })


}

function cleanResponse( arr )
{

    var selObj = document.getElementById( "codlocal") ;


    var selectedIndex = []
    var selectedValue = []



    for (var i=0; i<selObj.options.length; i++) { 
        if ( arr.includes(selObj.options[i].value)) {

            selectedIndex.push( i ) ;
            selectedValue.push( selObj.options[i].value )
        
        } 

    }


    console.log( "selectedIndex = " + selectedIndex.length ) ;


    for( i = selectedIndex.length -1 ; i >=0  ; i--)
    {
        console.log( "Borrando " + i )
        selObj.remove( selectedIndex[i] ) ;

    }

    setBorradoExit( true  ) ;


}


function onRight()
{
    console.log( "onRight") ;

    var selObj = document.getElementById( "codglobal") ;

    var selectedText = [] ;
    var selectedValue = []



    for (var i=0; i<selObj.options.length; i++) { 
        if (selObj.options[i].selected) {
            selectedText.push( selObj.options[i].text )
            selectedValue.push( selObj.options[i].value )
        
        } 

    }


    console.log( "values = " +  selectedText )


    addCatalogo( selectedValue , selectedText  )

}

function addCatalogo( value , text  )
{
    var select = document.getElementById('codlocal') ;


    if ( select === null || select === undefined)
    {
        console.log( "no encontre el codigo") ;
        return ;
    }


    // while( select.length > 0 )
    // {
    //     select.remove( select.length -1 ) ;
    // }

    for( var i = 0 ; i < value.length ; i++)
    {
       

        var option = document.createElement("option");
        option.value = value[i];
        option.text =  text[i]  ;
        select.appendChild(option)

    }


}

function setLocal( codigoAgrupador )
{
    var select = document.getElementById('codlocal') ;

    console.log( "dentro de setLocal ", codigoAgrupador.length)


    if ( select === null || select === undefined)
    {
        console.log( "no encontre el codigo " ) ;
        return ;
    }


    while( select.length > 0 )
    {
        select.remove( select.length -1 ) ;
    }

    for( var i = 0 ; i < codigoAgrupador.length ; i++)
    {
        var option = document.createElement("option");
        option.value = codigoAgrupador[i].codigo ;
        option.text =  codigoAgrupador[i].codigo + "  " + codigoAgrupador[i].nombre  ;
        select.appendChild(option)

    }



}

function setGlobal(codigoAgrupador)
{        
    var select = document.getElementById('codglobal') ;


    if ( select === null || select === undefined)
    {
        console.log( "no encontre el codigo") ;
        return ;
    }


    while( select.length > 0 )
    {
        select.remove( select.length -1 ) ;
    }

    for( var i = 0 ; i < codigoAgrupador.length ; i++)
    {
        var option = document.createElement("option");
        option.value = codigoAgrupador[i].codigo ;
        option.text =  codigoAgrupador[i].codigo + "  " + codigoAgrupador[i].nombre  ;
        select.appendChild(option)

    }


}




    useEffect(()=>{

        axios.get( "http://localhost:3004/livefactura/getcodigoagrupador?parms="  )
        .then( ( response ) => {

            setGlobal( response.data )

            getCodigoLocal()

            return ;

        } )
        .catch((err) => {

            console.log( err ) ;

            return ;

        })


    } ,[])



    function getCodigoLocal( )
    {
        axios.get( "http://localhost:3004/livefactura/getcodigoagrupadorlocal?parms="  )
        .then( ( response ) => {

            setLocal( response.data )

            return ;

        } )
        .catch((err) => {

            console.log( err ) ;

            return ;

        })

    }

    function onClose()
    {
        console.log( "onClose")

        close() ; 

    }
  return (
    <>

        <Container className='d-flex flex-column  align-items-center'  >
    
        <div className=" d-flex flex-column  box-1 backemployer-2 mb-5 " 
        style={{paddingTop:'31px' , width :'85%' , height :'80vh' , position:'relative'}} > 


        <Row >
            <Col className='col-11'>
                <div style={{display:'flex'}} >
                    <FontAwesomeIcon icon={faFileInvoice} style={{color:'grey' , height:20 , paddingTop:'5px'}}/>
                    <p style={{fontSize:'20px' , paddingLeft : '5px' , marginBottom : '2px'}}>Configuración de Catalogo de Cuentas</p>
                </div>
                
            </Col>
            {/* <Col className='col-4'/> */}
            
            <Col className='col-1'>
                <FontAwesomeIcon className='pt-2 ps-2' onClick={onClose} icon={faXmarkCircle} 
                title='Close' style={{color:'gray' , height:25 }}/>
            </Col>



        </Row>


        {
                        sinDatos && (

                            <>
                                <div className='  ' style={{position:'absolute' , marginLeft:'20%' , width:'60%' }}>
                                    <AlertSinDatos cerrar={cerrarSinDatos}></AlertSinDatos>
                                </div>
                            </>

                        

                        )
                    }


        <div className="row h-100" >

                <div className='col-sm-6' >
                    <label htmlFor="codglobal">Codigo Global:</label>
                    <select className="form-select h-100" multiple id="codglobal" aria-label="Default select example">
                    </select>                
                </div>

                <div className='col-sm-1' style={{paddingTop:'100px' , paddingLeftLeft :'0px'}}>
                    <div >
                        <FontAwesomeIcon  className='pt-2 ps-2'  icon={faRightLong} onClick={onRight}
                            title='Agregar' style={{color:'black' , height:'40px' , width :'40px' }}/>

                    </div>


                    <div >
                        <FontAwesomeIcon  className='pt-2 ps-2'  icon={faLeftLong} onClick={onLeft}
                            title='Quitar' style={{color:'black' , height:'40px' , width :'40px' }}/>

                    </div>

                    <div>
                        <FontAwesomeIcon className='pt-2 ps-2' onClick={onSaveAll} icon={faDownload} 
                        title='Almacenar' style={{color:'black', height:'40px' , width :'40px' }}/>

                    </div>     

                    <div >
                        <FontAwesomeIcon className='pt-2 ps-2' onClick={onEraseAll} icon={faTrash} 
                        title='Borrar Todo' style={{color:'black', height:'40px' , width :'40px' }}/>




                    </div>                    
            



                </div>



                <div className='col-sm-5'>
                    <label htmlFor="codlocal">Codigo Local:</label>

                    {
                        borradoExit && (
                        <>
                            <div className='w-50' style={{position:'absolute' ,top:'150px' , right :'90px'}}>
                                <AlertBorradoExit cerrar={cerrarBorrado}></AlertBorradoExit>
                            </div>
                        </>

                    
                    )
                    }

                    {
                        precaucion && (
                            <>
                                <div className='w-50' style={{position:'absolute' ,top:'150px' , right :'90px'}}>
                                    <AlertPrecaucion aceptar={aceptarPrecaucion} cerrar={cerrarPrecaucion}></AlertPrecaucion>
                                </div>
                            </>


                        
                        )
                    }

                    {/* {
                        sinDatos && (

                            <>
                                <div className='w-50' style={{position:'absolute' ,top:'150px' , right :'90px'}}>
                                    <AlertSinDatos cerrar={cerrarSinDatos}></AlertSinDatos>
                                </div>
                            </>

                        

                        )
                    } */}

                    <select multiple className="form-select h-100" id="codlocal" aria-label="Default select example">
                        

                    </select>                
                </div>

    




        </div>                

        </div>

        </Container>




    </>
    
  )
}

export default FormCatConfig